import { Card } from '../../../Common/Charts/Card';
import { number } from '../../../Common/Util/number';
import { useStratifiedProductionChartsDataContext } from './hooks/useStratifiedProductionChartsDataContext';

export const Indicators = () => {
    const { chartData } = useStratifiedProductionChartsDataContext();

    return (
        <div className="w-100">
            <Card
                title="Total de Atendimentos"
                value={number.formatToBRNumber(
                    chartData?.indicators?.totalServices || 0
                )}
            />
        </div>
    );
};
